module.exports = __webpack_public_path__ + "static/dev-2-6ef67f9a12cf46c381e58449cd419b43.jpg";